import axios, { getData } from "../../axios";
import * as tPromise from "io-ts-promise";
import {
  LoginCodeInput,
  loginCodeInputT,
  loginCodeResendResultT,
  loginCodeStatusT,
  loginCodeVerifyResultT,
} from "dora-contracts";
import { createErrorReportingAsyncThunk } from "../helpers";

// The second step of logging in for users who get an emailed login code.
// No state is kept here: the login-code page shows each result itself.

const prefix = "auth/login-code";

export const loadLoginCodeStatus = createErrorReportingAsyncThunk(
  `${prefix}/status`,
  () =>
    axios
      .get("/auth/login-code/status")
      .then(getData)
      .then(tPromise.decode(loginCodeStatusT))
);

export const verifyLoginCode = createErrorReportingAsyncThunk(
  `${prefix}/verify`,
  (input: LoginCodeInput) =>
    axios
      .post("/auth/login-code/verify", loginCodeInputT.encode(input))
      .then(getData)
      .then(tPromise.decode(loginCodeVerifyResultT))
);

export const resendLoginCode = createErrorReportingAsyncThunk(
  `${prefix}/resend`,
  () =>
    axios
      .post("/auth/login-code/resend")
      .then(getData)
      .then(tPromise.decode(loginCodeResendResultT))
);
